
import React, {useEffect, useRef, useState} from 'react'
import Seo from './Seo'
import Contact from './conatct'
import HeaderRightIMG from '../assets/images/vAutomate_Inner-Illustration.png'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import CheckIcon from '../assets/images/Check Icon.svg'
import Footer from './footer'
import DownloadBrochure from './downloadBrochure'
import {ScrollEffect} from 'react-easy-scroll-effect'
import featureIMGOne from '../assets/images/VNC-sample.png'
import featureImgTwo from '../assets/images/IT-User.gif'
import PHImg from '../assets/images/Banner/vAutomate.png'
import RequestDemo from './RequestDemo'

import featureImg1 from '../assets/images/Topoligy.png'
import featureImg2 from '../assets/images/Predefined-Configuration-Template.png'
import featureImg3 from '../assets/images/ITSM-Integration.png'
import featureImg4 from '../assets/images/Indepth-Logigin.png'
import featureImg5 from '../assets/images/Automated-Validation-Checks.png'
import featureImg6 from '../assets/images/Automated-Rollback.png'
import featureImg7 from '../assets/images/Comprehensive-System-Management.png'

export default function VAutomate() {

    const modalRef = useRef();
    const downlaodBroRef = useRef();
    
    const [featureText, setFeatureText] = useState('It learns from standard Network Management Systems (NMS) to create accurate network topologies.')
    const [featureImg, setFeatureImg] = useState(featureImg1)
    const onHoverFeatureText=(type)=>{ 
        if(type === 'featureOne'){
           
            document.getElementById('featureOne').classList.add('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
           
            setFeatureText('It learns from standard Network Management Systems (NMS) to create accurate network topologies.')
        setFeatureImg(featureImg1)
        } else if(type === 'featureTwo'){
            document.getElementById('featureTwo').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
            setFeatureText('Streamlines configurations with template-based predefined settings.')
        setFeatureImg(featureImg2)
        } else if(type === 'featureThree'){
           
            document.getElementById('featureThree').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
            setFeatureText('Seamlessly integrates with standard IT Service Management (ITSM) systems for streamlined workflow management.')
        setFeatureImg(featureImg3)
        } else if(type === 'featureFour'){
            document.getElementById('featureFour').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
            setFeatureText('Provides internal logs for effective troubleshooting and forensic analysis.')
        setFeatureImg(featureImg4)
        } else if(type === 'featureFive'){
            document.getElementById('featureFive').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
            setFeatureText('Conducts both pre- and post-configuration validation to ensure accuracy.')
        setFeatureImg(featureImg5)
        } else if(type === 'featureSix'){
            document.getElementById('featureSix').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            document.getElementById('featureSeven').classList.remove('active')
            setFeatureText('Features an automatic rollback function for validation failures to maintain network integrity.')
        setFeatureImg(featureImg6)
        } else if(type === 'featureSeven'){
            document.getElementById('featureSeven').classList.add('active')
            document.getElementById('featureOne').classList.remove('active')
            document.getElementById('featureTwo').classList.remove('active')
            document.getElementById('featureFour').classList.remove('active')
            document.getElementById('featureFive').classList.remove('active')
            document.getElementById('featureSix').classList.remove('active')
            document.getElementById('featureThree').classList.remove('active')
            setFeatureText('Includes alerts and notifications, time-stamped action logs, and role-based access controls.')
            setFeatureImg(featureImg7)
        } 
    }

    const reqDemoClick = () =>{
        modalRef.current.openModal()
    }

    const downloadBroClick = (val) =>{
        downlaodBroRef.current.openModal()
        downlaodBroRef.current.cnameFun(val)
    }
    useEffect(()=>{
        document.getElementById('featureOne').classList.add('active')
        window.scrollTo(0, 0);
        document.title = 'vAutomate | Agilus Technologies'
    },[])
  return (
    <div>
      <Seo
        title="vAutomate"
        description="vAutomate by Agilus streamlines network operations, standardizes configurations, reduces manual errors and enhances reliability."
        path="/vAutomate"
      />
        {/* img section */}
        <section className='custom-margin-for-header'>
            <img src={PHImg} className='img-fluid' />
        </section>
        {/* hero section */}
        <section className='ce-hero-section py-5'>
            <Container >
                <Row>
                <Col sm={12} className='text-center mb-3'><h1 className='fw-normal font-50 archivo-medium'>vAutomate</h1></Col>
                <Col sm={6} className='align-content'>
                    <p className='mb-3 inter-normal'>vAutomate is an advanced automation engine for network configuration management. This powerful tool streamlines network configurations from Day 0 to Day 2, employing sophisticated techniques for automation.</p>
                    <p className='inter-normal'>It's designed to significantly reduce human error, boost efficiency, and support scalable network operations. Adapting to changing network needs, vAutomate ensures operational consistency and maintains robust network infrastructures.</p>
                    
                </Col>
                <Col sm={6} className='align-content'>
                <img src={HeaderRightIMG} alt='' className='platform-img-width' />
                </Col>
                </Row>
            </Container>

        </section>

          {/* network complience */}
          <section className='netwotk-complience px-3 my-5'>
              <div className='bg-light-gray p-5 custom-rounded'>
                  <ScrollEffect id='2'>
                      <Container>
                          <Row>
                              <Col sm={12} className='align-content'>
                                  <h1 className='archivo-normal'>Features and Benefits</h1>

                                  <div className='highlight-points'>
                                      <div className='highlight-points-items'>

                                          <div class="container">
                                              <div class="row my-4">
                                                  <div class="col-md-6 col-lg-5 mb-3 mb-lg-0 ps-0">
                                                      <div class="list-group list-group-flush archivo-normal">
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureOne' onMouseEnter={() => onHoverFeatureText('featureOne')} >Intelligent Learning & Topology Creation <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureTwo' onMouseEnter={() => onHoverFeatureText('featureTwo')} >Predefined Configuration Templates <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureThree' onMouseEnter={() => onHoverFeatureText('featureThree')} >ITSM Integration <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureFour' onMouseEnter={() => onHoverFeatureText('featureFour')} >In-depth Logging <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureFive' onMouseEnter={() => onHoverFeatureText('featureFive')} >Automated Validation Checks <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureSix' onMouseEnter={() => onHoverFeatureText('featureSix')} >Automated Rollback <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          <span className="cursor-pointer py-4 fw-semibold featureTitle px-4 bg-white border-bottom" id='featureSeven' onMouseEnter={() => onHoverFeatureText('featureSeven')} >Comprehensive System Management <i class="ms-2 me-3 arrowBold right float-end" style={{ marginTop: 14 }}></i></span>
                                                          
                                                      </div>
                                                  </div>


                                                  <div class="col-md-6 col-lg-7 mb-3 mb-lg-0">
                                                      <div>
                                                          <p contentEditable='false' className='ms-2 inter-normal' dangerouslySetInnerHTML={{ __html: featureText }}></p>
                                                          <img src={featureImg} className='img-fluid' />
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>


                                      </div>
                                  </div>
                              </Col>
                          </Row>
                      </Container>
                  </ScrollEffect>
              </div>
          </section>

        

        {/* why agilus */}
        <section className='agilus-why text-center px-3 mt-5'>
        <div className='p-5 custom-rounded position-relative'>
        {/* <div className='position-absolute agilus-why-bg-back'></div> */}
        <ScrollEffect id='4'>
            <Container className='position-relative why-agilus-con-width'>
                 
            <Col sm={12}>
            <h1 className='mb-5 archivo-semibold font-45'>Why Choose <br/>vAutomate?</h1>
            </Col>
              <Row>
                <Col col={12} md={12} lg={6} xl={6}  className='agilus-why-item-box'>
                    <div className='agilus-why-item'>
                        <div className='agilus-why-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" height="48" width="48">
                          <path fill="currentColor" d="M21.75 31.5H12V28.5H21.75C22.7081 28.5004 23.6479 28.7629 24.4675 29.2592C25.287 29.7555 25.9552 30.4666 26.3995 31.3154C26.8438 32.1643 27.0473 33.1186 26.9881 34.0749C26.9288 35.0312 26.6089 35.953 26.0632 36.7405C25.5174 37.528 24.7666 38.1511 23.892 38.5424C23.0174 38.9336 22.0524 39.0781 21.1016 38.9601C20.1508 38.8421 19.2503 38.4661 18.4979 37.873C17.7455 37.2798 17.1697 36.492 16.833 35.595L19.6425 34.5405C19.7868 34.925 20.0335 35.2626 20.3559 35.5169C20.6784 35.7711 21.0643 35.9323 21.4718 35.9829C21.8793 36.0335 22.2928 35.9716 22.6677 35.804C23.0425 35.6363 23.3643 35.3693 23.5983 35.0318C23.8322 34.6943 23.9693 34.2993 23.9947 33.8894C24.0202 33.4796 23.933 33.0706 23.7426 32.7068C23.5522 32.343 23.2659 32.0382 22.9146 31.8255C22.5634 31.6127 22.1606 31.5002 21.75 31.5ZM13.5 22.5H33.75C34.7081 22.5004 35.6479 22.7629 36.4675 23.2592C37.287 23.7555 37.9552 24.4666 38.3995 25.3154C38.8438 26.1643 39.0474 27.1186 38.9881 28.0749C38.9288 29.0311 38.6089 29.953 38.0632 30.7405C37.5174 31.528 36.7666 32.1511 35.892 32.5424C35.0174 32.9336 34.0524 33.0781 33.1016 32.9601C32.1508 32.8421 31.2503 32.4661 30.4979 31.873C29.7455 31.2798 29.1697 30.492 28.833 29.595L31.6425 28.5405C31.7868 28.925 32.0335 29.2626 32.3559 29.5169C32.6784 29.7711 33.0643 29.9323 33.4718 29.9829C33.8793 30.0335 34.2928 29.9716 34.6677 29.804C35.0425 29.6363 35.3644 29.3693 35.5983 29.0318C35.8322 28.6943 35.9693 28.2993 35.9947 27.8894C36.0202 27.4796 35.933 27.0706 35.7426 26.7068C35.5522 26.343 35.2659 26.0382 34.9146 25.8255C34.5634 25.6127 34.1606 25.5002 33.75 25.5H13.5C12.3065 25.5 11.1619 25.0259 10.318 24.182C9.47411 23.3381 9 22.1935 9 21C9 19.8066 9.47411 18.662 10.318 17.8181C11.1619 16.9741 12.3065 16.5 13.5 16.5H26.25C26.6606 16.4999 27.0634 16.3873 27.4146 16.1746C27.7659 15.9619 28.0522 15.6571 28.2426 15.2933C28.433 14.9295 28.5202 14.5205 28.4947 14.1107C28.4693 13.7008 28.3322 13.3058 28.0983 12.9683C27.8643 12.6308 27.5425 12.3638 27.1677 12.1961C26.7928 12.0285 26.3793 11.9666 25.9718 12.0172C25.5643 12.0678 25.1784 12.229 24.8559 12.4832C24.5335 12.7374 24.2868 13.0751 24.1425 13.4595L21.333 12.4065C21.7657 11.2557 22.5885 10.2932 23.6579 9.68675C24.7274 9.08026 25.9757 8.86821 27.1854 9.08756C28.3952 9.30691 29.4896 9.94375 30.278 10.8871C31.0664 11.8305 31.4989 13.0206 31.5 14.25C31.5 15.6424 30.9469 16.9778 29.9623 17.9623C28.9777 18.9469 27.6424 19.5 26.25 19.5H13.5C13.1022 19.5 12.7206 19.6581 12.4393 19.9394C12.158 20.2207 12 20.6022 12 21C12 21.3979 12.158 21.7794 12.4393 22.0607C12.7206 22.342 13.1022 22.5 13.5 22.5Z"></path>
                          </svg>
                        </div>
                        <h2 className='mb-3'>Boost Productivity through Automation</h2>
                        <p className='agilus-content'>Using vAutomate for configuration can save up to 80% of time by automating pre-checks, configurations, and post-checks, ensuring both accuracy and efficiency while reducing effort.</p>
                    </div>
                </Col>
               <Col col={12} md={12} lg={6} xl={6}  className='agilus-why-item-box'>
                    <div className='agilus-why-item'>
                        <div className='agilus-why-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" height="48" width="48">
                          <path fill="currentColor" d="M21.75 31.5H12V28.5H21.75C22.7081 28.5004 23.6479 28.7629 24.4675 29.2592C25.287 29.7555 25.9552 30.4666 26.3995 31.3154C26.8438 32.1643 27.0473 33.1186 26.9881 34.0749C26.9288 35.0312 26.6089 35.953 26.0632 36.7405C25.5174 37.528 24.7666 38.1511 23.892 38.5424C23.0174 38.9336 22.0524 39.0781 21.1016 38.9601C20.1508 38.8421 19.2503 38.4661 18.4979 37.873C17.7455 37.2798 17.1697 36.492 16.833 35.595L19.6425 34.5405C19.7868 34.925 20.0335 35.2626 20.3559 35.5169C20.6784 35.7711 21.0643 35.9323 21.4718 35.9829C21.8793 36.0335 22.2928 35.9716 22.6677 35.804C23.0425 35.6363 23.3643 35.3693 23.5983 35.0318C23.8322 34.6943 23.9693 34.2993 23.9947 33.8894C24.0202 33.4796 23.933 33.0706 23.7426 32.7068C23.5522 32.343 23.2659 32.0382 22.9146 31.8255C22.5634 31.6127 22.1606 31.5002 21.75 31.5ZM13.5 22.5H33.75C34.7081 22.5004 35.6479 22.7629 36.4675 23.2592C37.287 23.7555 37.9552 24.4666 38.3995 25.3154C38.8438 26.1643 39.0474 27.1186 38.9881 28.0749C38.9288 29.0311 38.6089 29.953 38.0632 30.7405C37.5174 31.528 36.7666 32.1511 35.892 32.5424C35.0174 32.9336 34.0524 33.0781 33.1016 32.9601C32.1508 32.8421 31.2503 32.4661 30.4979 31.873C29.7455 31.2798 29.1697 30.492 28.833 29.595L31.6425 28.5405C31.7868 28.925 32.0335 29.2626 32.3559 29.5169C32.6784 29.7711 33.0643 29.9323 33.4718 29.9829C33.8793 30.0335 34.2928 29.9716 34.6677 29.804C35.0425 29.6363 35.3644 29.3693 35.5983 29.0318C35.8322 28.6943 35.9693 28.2993 35.9947 27.8894C36.0202 27.4796 35.933 27.0706 35.7426 26.7068C35.5522 26.343 35.2659 26.0382 34.9146 25.8255C34.5634 25.6127 34.1606 25.5002 33.75 25.5H13.5C12.3065 25.5 11.1619 25.0259 10.318 24.182C9.47411 23.3381 9 22.1935 9 21C9 19.8066 9.47411 18.662 10.318 17.8181C11.1619 16.9741 12.3065 16.5 13.5 16.5H26.25C26.6606 16.4999 27.0634 16.3873 27.4146 16.1746C27.7659 15.9619 28.0522 15.6571 28.2426 15.2933C28.433 14.9295 28.5202 14.5205 28.4947 14.1107C28.4693 13.7008 28.3322 13.3058 28.0983 12.9683C27.8643 12.6308 27.5425 12.3638 27.1677 12.1961C26.7928 12.0285 26.3793 11.9666 25.9718 12.0172C25.5643 12.0678 25.1784 12.229 24.8559 12.4832C24.5335 12.7374 24.2868 13.0751 24.1425 13.4595L21.333 12.4065C21.7657 11.2557 22.5885 10.2932 23.6579 9.68675C24.7274 9.08026 25.9757 8.86821 27.1854 9.08756C28.3952 9.30691 29.4896 9.94375 30.278 10.8871C31.0664 11.8305 31.4989 13.0206 31.5 14.25C31.5 15.6424 30.9469 16.9778 29.9623 17.9623C28.9777 18.9469 27.6424 19.5 26.25 19.5H13.5C13.1022 19.5 12.7206 19.6581 12.4393 19.9394C12.158 20.2207 12 20.6022 12 21C12 21.3979 12.158 21.7794 12.4393 22.0607C12.7206 22.342 13.1022 22.5 13.5 22.5Z"></path>
                          </svg>
                        </div>
                        <h2 className='mb-3'>Ensure Best Practices</h2>
                        <p className='agilus-content'>Provisioning your devices through vAutomate ensures that all the network configuration best practices are applied across all the network devices.</p>
                    </div>
                </Col>
                </Row>
                <Row>
                
               
              </Row>
            </Container>
            </ScrollEffect>
            </div>
        </section>

        {/* request demo  */}
        <section className='request-demo pb-5 my-4 archivo-normal'>
            <Container className='bg-dark text-center text-white custom-rounded-wrapper-specific custom-rounded p-5 request-demo-box'>
                <Row>
                    <Col col={12} md={12} lg={12} xl={12} className='align-content'>
                                            <h1 className='archivo-semibold font-45'>Ensure Consistent Best Practices Across All Devices – Provision and Automate Network Configurations with vAutomate!</h1> 
                                        </Col>
                                        <Col col={12} md={12} lg={12} xl={12} className='align-content'>
                                        {/* <p className='inter-normal'>Experience vAutomate Request a demo</p> */}
                        <button className='btn-custom mt-2 d-inline-block' onClick={()=>reqDemoClick()}>Request a Demo → </button>
                    </Col>
                </Row>
            </Container>
        </section>

        <Contact />

        {/* request demo  */}
        {/* <section className='download-brochure archivo-normal text-center'>
            <Container className='p-5'>
                <Row>
                <Col sm={12}>
                        <h1 className='font-40'>For detailed specifications and insights Download Platform Datasheet</h1>
                        <p className='fw-normal'>Download platform datasheet</p>
                        <button className='btn-cutom-outline mt-2 d-inline-block' onClick={()=> downloadBroClick({ title : 'Download Brochure →',  cname : 'vAutomate'})} >Download Brochure →</button>
                        <DownloadBrochure title='Download Brochure →' cName='vAutomate'  ref={downlaodBroRef}/>
                    </Col>
                </Row>
            </Container>
        </section> */}

      {/* footer */}
      <Footer />

      <RequestDemo  ref={modalRef}/>
    </div>
  )
}


